'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  right: ', ';\n  top: ', ';\n'], ['\n  right: ', ';\n  top: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  @media only screen and (min-width: 50em) {\n    color: ', ';\n    position: absolute;\n    ', ';\n\n    &::after {\n      background: ', ';\n    }\n  }\n'], ['\n  @media only screen and (min-width: 50em) {\n    color: ', ';\n    position: absolute;\n    ', ';\n\n    &::after {\n      background: ', ';\n    }\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  ', ';\n'], ['\n  ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Color = require('../core/Color');

var _Hoverable = require('../decorators/Hoverable');

var _Hoverable2 = _interopRequireDefault(_Hoverable);

var _Style = require('../core/Style');

var _colors = require('HubStyleTokens/colors');

var _UICloseButton = require('../button/UICloseButton');

var _UICloseButton2 = _interopRequireDefault(_UICloseButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var DETACHED_OFFSET = 40;

var getOffset = (0, _styledComponents.css)(_templateObject, (0, _Style.remCalc)(DETACHED_OFFSET), (0, _Style.remCalc)(DETACHED_OFFSET));

var getDetachedStyle = function getDetachedStyle(hovered, size) {
  return (0, _styledComponents.css)(_templateObject2, hovered && _colors.MONOLITH, size === 'xl' && getOffset, (0, _Color.rgba)(_colors.OLAF, 0.1));
};

var CloseButton = (0, _styledComponents2.default)(function (props) {
  var __detached = props.detached,
      rest = _objectWithoutProperties(props, ['detached']);

  return _react2.default.createElement(_UICloseButton2.default, rest);
}).withConfig({
  displayName: 'UIDialogCloseButton__CloseButton'
})(_templateObject3, function (props) {
  return props.detached && getDetachedStyle(props.hovered, props.size);
});

var UIDialogCloseButton = _react2.default.createClass({
  displayName: 'UIDialogCloseButton',

  propTypes: {
    className: _react.PropTypes.string,
    detached: _react.PropTypes.bool.isRequired,
    size: _UICloseButton2.default.propTypes.size
  },

  getDefaultProps: function getDefaultProps() {
    return {
      detached: false
    };
  },
  render: function render() {
    var _props = this.props,
        className = _props.className,
        detached = _props.detached,
        size = _props.size,
        rest = _objectWithoutProperties(_props, ['className', 'detached', 'size']);

    var computedSize = detached && size == null ? 'xl' : size;
    return _react2.default.createElement(CloseButton, _extends({
      className: (0, _reactUtils.classNames)('uiDialog-closeButton', 'private-modal__control', 'private-modal__close', className)
    }, rest, {
      detached: detached,
      size: computedSize
    }));
  }
});

exports.default = (0, _Hoverable2.default)(UIDialogCloseButton);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1282/js/dialog/UIDialogCloseButton.js
// module id = 171
// module chunks = 0